import { Component, OnInit } from '@angular/core';
import { Routes } from '../models/routes';
import { MatDialog } from '@angular/material/dialog';
import { SmsService } from '../services/sms.service';

@Component({
  selector: "app-send-sms",
  templateUrl: "./send-sms.component.html",
  styleUrls: ["./send-sms.component.css"],
})
export class SendSmsComponent implements OnInit {
  showLoader: boolean = true;

  categories: any[] = [];

  route: Routes = new Routes();

  emailFormArray: any[] = [];
  // checkedCategoryList:any;

  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  isSelected = false;
  a = false;
  isMasterSel: boolean;
  selectedMode: string = "15";
  currentPage = 1;
  totalItems: 0;
  limit = 15;
  search:string=""
  constructor(private smsService: SmsService, public dialog: MatDialog) {}

  ngOnInit(): void {
    //  this.getAllUserPhoneNumber();
    //  this.getCheckedItemList();
    this.updateView();
    this.getCheckedItemList()
  }

  updateView() {
    if (this.selectedMode === "15") {
      this.limit = 15;
      this.currentPage = 1
      this.getAllUserPhoneNumber(this.currentPage, this.limit, this.search);
      this.isMasterSel = false;
      this.a = false;
      this.search = "";
    }else if(this.selectedMode === "50"){
      this.limit = 50;
      this.currentPage = 1
      this.getAllUserPhoneNumber(this.currentPage, this.limit,this.search);
      this.isMasterSel = false;
      this.a = false;
      this.search = "";
    } 
    else {
      this.getAllUserWitoutPagination(this.search);
          this.isMasterSel = false;
          this.a = false;
          this.search=""
    }
  }

  onSearch() {
    if(this.selectedMode==="15" || this.selectedMode==="50"){
      this.currentPage = 1
      this.getAllUserPhoneNumber(this.currentPage, this.limit);
    }
    else{
      this.getAllUserWitoutPagination(this.search);
    }
}

  getAllUserWitoutPagination(search = this.search) {
    this.smsService.getSmsWithoutPagination(search).subscribe(
      (response: any) => {
        this.showLoader = false;
        this.categories = response.data;
        console.log("categories", this.categories);
        
  const stored = JSON.parse(
        localStorage.getItem("selectedSmsUsers") || "[]"
      );
      this.categories.forEach((item) => {
        item.isSelected = stored.includes(item._id);
        console.log("item.isselected", stored.includes(item._id))
      });
        // $(document).ready(function () {
        //   $("#example").DataTable();
        // });
      },
      (error) => (this.showLoader = false)
    );
  }

  getAllUserPhoneNumber(page: number = this.currentPage , limit = this.limit, search = this.search) {
    this.smsService.getBulkSms(page, limit,search ).subscribe((response: any) => {
      this.showLoader = false;
      this.categories = response.data;
      this.totalItems = response.totalUsers;
      console.log("categories", this.categories);

      const stored = JSON.parse(
        localStorage.getItem("selectedSmsUsers") || "[]"
      );
      this.categories.forEach((item) => {
        item.isSelected = stored.includes(item._id);
        console.log("item.isselected", stored.includes(item._id))
      });

      this.isAllSelected();
    });
  }

  onPageChange(page: number) {
    page = Number(page);
    this.currentPage = page;
    console.log(
      "Before request -> currentPage:",
      this.currentPage,
      "limit:",
      this.limit,
      "total:",
      this.totalItems
    );
    this.getAllUserPhoneNumber(page, this.limit, this.search);
  }

  checkUncheckAll() {
    if (this.selectedMode === "all") {
      for (var i = 0; i < this.categories?.length; i++) {
        this.categories[i].isSelected = this.isMasterSel;
        this.smsService.isSelectedAll = this.isMasterSel;
      }
      this.getCheckedItemList();
      return;
    }
    else if(this.selectedMode === "15" || this.selectedMode === "50"){

      this.categories.forEach((item) => {
        item.isSelected = this.isMasterSel;
      });
      this.smsService.isSelectedAll = false
      this.getCheckedItemList();
    }

  }

  // isAllSelected() {
  // this.isMasterSel = this.categories.every(item => item.isSelected);
  // if (!this.isMasterSel && this.selectedMode === "all") {
  //   this.smsService.isSelectedAll = false;
  // }

  //   this.getCheckedItemList();  
  // }

  isAllSelected() {
  const allSelected = this.categories.every(item => item.isSelected);

  // If user manually changes selection after selecting all, disable select-all mode
  if (this.selectedMode === "all" && this.smsService.isSelectedAll && !allSelected) {
    this.smsService.isSelectedAll = false;
  }

  this.isMasterSel = allSelected;
  this.getCheckedItemList();
}


getCheckedItemList() {

  // SELECT ALL mode → skip storing
  if (this.selectedMode === "all" && this.smsService.isSelectedAll) {
    this.smsService.checkedCategoryList = [];
    this.a = true;
    localStorage.setItem("selectedSmsUsers", JSON.stringify([]));
    return;
  }

  // get stored selections
  const stored = JSON.parse(localStorage.getItem("selectedSmsUsers") || "[]");

  // find selected items in current page
  const currentSelected = this.categories
    .filter(item => item.isSelected)
    .map(item => item._id);
    console.log("currentSelected", currentSelected)

  // merge previous + current selections (avoid duplicates)
  const merged = [...new Set([...stored, ...currentSelected])];

  // remove items unselected on current page
  const pageIds = this.categories.map(item => item._id);
  const cleaned = merged.filter(id => !pageIds.includes(id) || currentSelected.includes(id));

  // save back
  this.smsService.checkedCategoryList = cleaned;
  this.a = cleaned.length > 0;

  localStorage.setItem("selectedSmsUsers", JSON.stringify(cleaned));

  console.log("Selected IDs:", cleaned);
}



  // getCheckedItemList() {
  //   if (this.selectedMode === "all") {
  //     if (!this.isMasterSel) {
  //       this.smsService.checkedCategoryList = [];
  //       for (var i = 0; i < this.categories?.length; i++) {
  //         if (this.categories[i].isSelected)
  //           this.smsService.checkedCategoryList.push(this.categories[i]._id);
  //         localStorage.setItem(
  //           "selectedSmsUsers",
  //           JSON.stringify(this.smsService.checkedCategoryList)
  //         );
  //       }
  //       console.log(this.smsService.checkedCategoryList?.length, "length");
  //       if (this.smsService.checkedCategoryList?.length > 0) {
  //         this.a = true;
  //       }
  //       if (this.smsService.checkedCategoryList?.length == 0) {
  //         this.a = false;
  //       }
  //     } else {
  //       this.a = true;
  //     }
  //   }else if(this.selectedMode === "15" || this.selectedMode === "50"){
  //       this.smsService.checkedCategoryList = [];
  //       for (var i = 0; i < this.categories?.length; i++) {
  //         if (this.categories[i].isSelected)
  //           this.smsService.checkedCategoryList.push(this.categories[i]._id);
  //         localStorage.setItem(
  //           "selectedSmsUsers",
  //           JSON.stringify(this.smsService.checkedCategoryList)
  //         );
  //       }
  //       console.log(this.smsService.checkedCategoryList?.length, "length");
  //       if (this.smsService.checkedCategoryList?.length > 0) {
  //         this.a = true;
  //       }
  //       if (this.smsService.checkedCategoryList?.length == 0) {
  //         this.a = false;
  //       }
      
  //   }
  // }
}
